// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1FPhP","content":"ManualTimeModal_content__b0eal"};